import { Command } from '@/app/tracking/api';

interface InteractionState {
  id: string
  type: string
  state: unknown
}

export type UpdateInteractionStateTrackingCommandPayload = InteractionState

export const UpdateInteractionStateTrackingCommandName = 'update-interaction-state' as const;
export type UpdateInteractionStateTrackingCommand =
      Command<typeof UpdateInteractionStateTrackingCommandName, UpdateInteractionStateTrackingCommandPayload>;
